import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const GardenIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.26 4.64938L2.75 2.47622L3.13 2.14722L5.26 3.99137V4.64938Z" fill="#23232D" />
            <path d="M1 4.64938V3.99137L3.13 2.14722L3.51 2.47622L1 4.64938Z" fill="#23232D" />
            <path d="M1.53 3.99133H1V7.91341H1.53V3.99133Z" fill="#23232D" />
            <path d="M9 7.54114H1V8.00001H9V7.54114Z" fill="#23232D" />
            <path d="M5.25998 3.99133H4.72998V7.58441H5.25998V3.99133Z" fill="#23232D" />
            <path d="M6.32999 5.69702H5.79999V7.59313H6.32999V5.69702Z" fill="#23232D" />
            <path d="M7.38999 4.31165H6.85999V7.59303H7.38999V4.31165Z" fill="#23232D" />
            <path d="M8.45999 5.69702H7.92999V7.59313H8.45999V5.69702Z" fill="#23232D" />
            <path d="M8.99999 6.15588H4.73999V6.61476H8.99999V6.15588Z" fill="#23232D" />
            <path
                d="M7.12999 2C6.35999 2 5.73999 2.62338 5.73999 3.38528C5.73999 4.14719 5.82999 3.95671 5.98999 4.18182C6.02999 4.23377 6.06999 4.28571 6.10999 4.33766C6.19999 4.4329 6.30999 4.51948 6.42999 4.58874C6.62999 4.70996 6.86999 4.77056 7.11999 4.77056C7.88999 4.77056 8.50999 4.14719 8.50999 3.38528C8.50999 2.62338 7.89999 2 7.12999 2ZM7.12999 4.25974C6.87999 4.25974 6.65999 4.15584 6.50999 3.98268C6.36999 3.82684 6.27999 3.61905 6.27999 3.38528C6.27999 2.90043 6.65999 2.51082 7.12999 2.51082C7.59999 2.51082 7.97999 2.90043 7.97999 3.38528C7.97999 3.87013 7.59999 4.25974 7.12999 4.25974Z"
                fill="#23232D"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const GardenIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.26 4.64938L2.75 2.47622L3.13 2.14722L5.26 3.99137V4.64938Z" fill="#23232D" />
            <path d="M1 4.64938V3.99137L3.13 2.14722L3.51 2.47622L1 4.64938Z" fill="#23232D" />
            <path d="M1.53 3.99133H1V7.91341H1.53V3.99133Z" fill="#23232D" />
            <path d="M9 7.54114H1V8.00001H9V7.54114Z" fill="#23232D" />
            <path d="M5.25998 3.99133H4.72998V7.58441H5.25998V3.99133Z" fill="#23232D" />
            <path d="M6.32999 5.69702H5.79999V7.59313H6.32999V5.69702Z" fill="#23232D" />
            <path d="M7.38999 4.31165H6.85999V7.59303H7.38999V4.31165Z" fill="#23232D" />
            <path d="M8.45999 5.69702H7.92999V7.59313H8.45999V5.69702Z" fill="#23232D" />
            <path d="M8.99999 6.15588H4.73999V6.61476H8.99999V6.15588Z" fill="#23232D" />
            <path
                d="M7.12999 2C6.35999 2 5.73999 2.62338 5.73999 3.38528C5.73999 4.14719 5.82999 3.95671 5.98999 4.18182C6.02999 4.23377 6.06999 4.28571 6.10999 4.33766C6.19999 4.4329 6.30999 4.51948 6.42999 4.58874C6.62999 4.70996 6.86999 4.77056 7.11999 4.77056C7.88999 4.77056 8.50999 4.14719 8.50999 3.38528C8.50999 2.62338 7.89999 2 7.12999 2ZM7.12999 4.25974C6.87999 4.25974 6.65999 4.15584 6.50999 3.98268C6.36999 3.82684 6.27999 3.61905 6.27999 3.38528C6.27999 2.90043 6.65999 2.51082 7.12999 2.51082C7.59999 2.51082 7.97999 2.90043 7.97999 3.38528C7.97999 3.87013 7.59999 4.25974 7.12999 4.25974Z"
                fill="#23232D"
            />
        </SvgIcon>
    );
};
